import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const appSectionStyles = {
  contentWrapper: (): SystemStyleObject<Theme> => ({
    display: "grid",
    gridTemplateColumns: { md: "5fr 7fr" },
    justifyItems: "center",
    gap: 3,
  }),
  itemsWrapper: (): SystemStyleObject<Theme> => ({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 3,
  }),
  imageWrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "relative",

    "&::before": {
      content: "''",
      position: "absolute",
      zIndex: 1,
      width: "100%",
      left: 0,
      height: "50%",
      pointerEvents: "none",
      bottom: 0,
      backgroundImage: `linear-gradient(0deg, ${theme.palette.background.default}, transparent)`,
    },
  }),
};

export default appSectionStyles;
